import $ from 'jquery'

const cache = {
  $window: $(window),
  $document: $(document),
  $html: $('html'),
  $body: $('body'),
  $htmlBody: $('html, body'),
  $header: $('#header'),
  $main: $('#main'),
  $mainAndFooter: $('#main, #footer'),
  $navSwitch: $('#nav-switch'),
  $jump: $('a[href*="#"]'),
  $formQty: $('.c-qty--input'),
  $formSignup: $('.c-signup__form'),
  $formMessage: $('.c-signup__msg'),
  $cartSwitch: $('#cart-switch'),
  $cart: $('#cart'),
  $galleryStory: $('#gallery-story'),
  $galleryRecipes: $('.c-gallery--recipes'),
  $gallerySpice: $('#gallery-spice'),
  $galleryGarden: $('#gallery-garden'),
  $galleryOpen: $('.open-recipe'),
  $galleryClose: $('.close-recipe'),
  $galleryBack: $('.c-gallery__back'),
  $cartButton: $('#AddToCart'),
  $productId: $('#ProductId'),
}

export default cache
